module.exports = __webpack_public_path__ + "static/media/2020.11.5卫生院助力膏方制作讲座.7ff03a0c.jpg";